import type { FC, ReactElement } from 'react';

import { Navigate } from 'react-router-dom';

import { useAppSelector } from '@app/store/store';
import { selectIsAuthenticated } from '@features/authentication/store/authentication.slice';

interface AuthProtectedRouteProps {
  children: ReactElement;
}

export const AuthProtectedRoute: FC<AuthProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to="/login" replace data-testid="auth-gate-navigate" />;
};
